import {RoomState} from '../../../../../shared/RoomState'
import {TranslationObject} from '@colonist/i18n'
import {RoomTab, UIMFullscreenTabView} from './UIMFullscreenTabView'
import {UIMRoomEditPageController} from './UIMRoomEditPageController'
import {UIMRoomSettingsController} from './UIMRoomSettingsController'

enum SetupPageTabs {
    SelectMode,
    SelectMap,
    SelectSettings,
}
export class UIMRoomSetupPageController extends UIMRoomEditPageController {
    roomSettingsController: UIMRoomSettingsController

    protected initializeRoomPageView() {
        const title: TranslationObject = {key: 'strings:roomPage.notifications.edit'}
        const tabProperties: RoomTab[] = [
            {
                title: {key: 'strings:game.settings.gameInfoTab.gameMode.titleAbbreviated'},
                isActive: true,
                containerClass: 'm-room-settings-cards-container',
                id: SetupPageTabs.SelectMode,
            },
            {
                title: {key: 'strings:game.settings.gameInfoTab.map.title'},
                isActive: false,
                containerClass: 'm-room-settings-cards-container',
                id: SetupPageTabs.SelectMap,
            },
            {
                title: {key: 'strings:game.gearIcon.settings'},
                isActive: false,
                containerClass: 'm-room-settings-cards-container',
                id: SetupPageTabs.SelectSettings,
            },
        ]
        const buttonText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.createRoom.title'}
        this.roomPageView = new UIMFullscreenTabView(title, tabProperties, buttonText)
    }

    protected async initializeControllers() {
        await super.initializeControllers()
        this.roomSettingsController = new UIMRoomSettingsController(this.roomPageView.getContainerWithTabIdx(SetupPageTabs.SelectSettings), this.roomState, (idx: number, playSound?: boolean) => this.roomPageView.updateActiveTabToIndex(idx, playSound))
    }

    update(roomState: RoomState) {
        super.update(roomState)
        this.roomSettingsController.update(roomState)
    }

    protected showRoomPage() {
        super.showRoomPage()
        this.roomSettingsController.setPrivateRoomStateSync(true)
    }
}
